import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=a93b0ecc&lang=css"

const __exports__ = script;

export default __exports__